import { DateFormats, isNullOrUndefined } from '@fabric-ui/utils';
import { Skeleton } from '@mui/material';
import { format } from 'date-fns';
import { DATE_BUCKET_TO_DATE_GAP } from '../FieldOptions';
import { TimeBucketSet, TimeBucketToDateGap } from './other.types';
import { FormatterType } from './types';

export const NO_VALUE = '—';
export const EMPTY_STRING = '" "';
export const getPercent = num => `${Math.round(num * 100) / 100}%`;
export const hasTimeBucket = (value: string) => TimeBucketSet.has(value);

export const generateInnerDefaultFormatter = ({ value, type, size = '', fieldName = '', shouldDisplayNull = false }) => {
  if (shouldDisplayNull) {
    if (value === '') {
      return EMPTY_STRING;
    }

    if (value === null || value === 'null') {
      return NO_VALUE;
    }
  }

  switch (type) {
    case FormatterType.boolean:
      return value?.toString();
    case FormatterType.number:
      return value && value.toLocaleString();
    case FormatterType.percentage:
      return isNullOrUndefined(value) ? '' : `${getPercent(value)}`;
    case FormatterType.date:
      return value && new Date(value).toLocaleString();
    case FormatterType.historicDate: {
      if (hasTimeBucket(fieldName)) {
        return value && format(new Date(value), DateFormats[TimeBucketToDateGap[fieldName]] || 'MMM');
      }
      return value && format(new Date(value), DateFormats[DATE_BUCKET_TO_DATE_GAP[fieldName]] || 'MMM');
    }
    case FormatterType.array:
      return Array.isArray(value)
        ? value.length > 0 && typeof value[0] === 'object'
          ? JSON.stringify(value)
          : value.join(', ')
        : value
          ? [value].join(', ')
          : '';
    case FormatterType.json:
      return JSON.stringify(value);
    case FormatterType.loading:
      return <Skeleton variant="text" height={size === 'tiles' ? 32 : 23} width={value} />;
    case FormatterType.string:
      return value;
    default: {
      return value?.toString();
    }
  }
};
